import { AnalyticsCallOptions, setUserId } from 'firebase/analytics';
import { getGoogleAnalytics } from 'services/firebase';

export const setUserAnalytics = async (id: string | null, options?: AnalyticsCallOptions | undefined) => {
  const analytics = await getGoogleAnalytics();
  if (analytics) setUserId(analytics, id);
};
